export default __webpack_public_path__ + "static/media/22.979b9b11.png";